module.exports = __webpack_public_path__ + "static/media/Mina-Bold.dff5e6c4.ttf";